export default __webpack_public_path__ + "static/media/bottom.1eda98ee.svg";